<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="万里牛订单" v-if="findChildren(40)!==-1" name="wlnorder" style="height: 100%;">
				<wlnorder-index />
			</el-tab-pane>
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import wlnorderIndex from './wlnorder/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: 'wlnorder',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			console.log(this.departmentChildren)
			// if(this.departmentChildren.length!=0){
			// 	this.activeName = this.departmentChildren[0].controller
			// }
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			wlnorderIndex,

		}
	}
</script>
